import VehicleCaptureDetails from '../../../models/vehicleCapture/VehicleCaptureDetails';

export default {
  vehicleCaptures: [],
  vehicleCapture: new VehicleCaptureDetails(),
};
